// import React, { useContext, useEffect, useState } from 'react'
// import { FaRupeeSign } from 'react-icons/fa'
// import { MdArrowRight, MdCalendarToday, MdCalendarViewDay, MdCalendarViewWeek, MdMonetizationOn, MdMoreHoriz, MdSearch } from 'react-icons/md'
// import TransactionsTable from '../../Components/Membership/TransactionsTable'
// import NavAtHome from '../../Components/Navigators/NavAtHome'
// import { BASE_URL_API } from '../../References/URLs'
// import AuthContext from '../../store/auth-context'
// import styles from '../Membership/CardDetails.module.css'
// import { useParams } from 'react-router';
// import { Link } from 'react-router-dom'
// import { ShimmerThumbnail } from 'react-shimmer-effects'
// import ExtendCard from '../../Components/Membership/ExtendCard'

// import { toast } from 'react-toastify';
// import { TbRecharging } from 'react-icons/tb'
// import { FiSettings } from 'react-icons/fi'
// import MembershipNavbar from '../../Components/Membership/MembershipNavbar'

// const CardDetails = () => {
//     const [isLoading, setIsLoading] = useState(true);
//     const authCtx = useContext(AuthContext);
//     const params = useParams();
//     const cardIdentifier = params.purchaseCardIdentifier;


//     const [clientDetails, setClientDetails] = useState({
//         clientName: ""
//     })
//     const [otherCards, setOtherCards] = useState([])
//     const [dcb, setDcb] = useState(null)
//     const [isExtending, setIsExtending] = useState(false)
//     const toggleIsExtending = () => {
//         setIsExtending(!isExtending)
//     }

//     const getClientMembershipDetails = async () => {
//         setIsLoading(true)
//         const getClientMembershipDetailsResponse = await fetch(BASE_URL_API + "getClientMembershipDetails",
//             {
//                 method: 'POST',
//                 body: JSON.stringify({
//                     token: authCtx.token,
//                     cardIdentifier: cardIdentifier
//                 })
//             });

//         if (!getClientMembershipDetailsResponse.ok) {
//             console.log("Something went wrong : Server Error");
//         } else {
//             const getClientMembershipDetailsRespo = await getClientMembershipDetailsResponse.json();
//             if (getClientMembershipDetailsRespo.status === "success") {
//                 setOtherCards(getClientMembershipDetailsRespo.response.otherCards)
//                 setClientDetails(getClientMembershipDetailsRespo.response.clientDetails)
//             } else {
//                 if (getClientMembershipDetailsRespo.message === "tokenExpired") {
//                     authCtx.logout()
//                 } else if (getClientMembershipDetailsRespo.message === "invalid token parts") {
//                     authCtx.logout()
//                 } else {
//                 }
//             }
//             console.log(getClientMembershipDetailsRespo);
//         }
//         setIsLoading(false)
//     }

//     const getCardsUsageAndBalance = async () => {
//         const getCardsUsageAndBalanceResponse = await fetch(BASE_URL_API + "getCardsUsageAndBalance",
//             {
//                 method: 'POST',
//                 body: JSON.stringify({
//                     token: authCtx.token,
//                     cardIdentifier: cardIdentifier
//                 })
//             });

//         if (!getCardsUsageAndBalanceResponse.ok) {
//             console.log("Something went wrong : Server Error")
//         } else {
//             const getCardsUsageAndBalanceRespo = await getCardsUsageAndBalanceResponse.json();
//             if (getCardsUsageAndBalanceRespo.status === 'success') {
//                 setDcb(getCardsUsageAndBalanceRespo.response)
//             } else {
//                 setDcb(null)
//             }
//             console.log(getCardsUsageAndBalanceRespo)
//         }
//     }

//     useEffect(() => {
//         getClientMembershipDetails().then(getCardsUsageAndBalance())
//     }, [cardIdentifier])


//     console.log(dcb)

//     return (
//         <div className={styles.mainWrapper}>
//             <MembershipNavbar />
//             <ExtendCard
//                 isExtending={isExtending}
//                 toggleIsExtending={toggleIsExtending}
//                 cardIdentifier={cardIdentifier}
//                 getClientMembershipDetails={getClientMembershipDetails}
//                 getCardsUsageAndBalance={getCardsUsageAndBalance}

//             />
//             <div className={styles.mainContainer}>
//                 <div className={styles.upperWrapper}>
//                     <div className={styles.mainHeader}>
//                         <div className={styles.mhLeft}>
//                             <div className={styles.clientNameTitle}>
//                                 Welcome
//                             </div>
//                             <div className={styles.clientName}>
//                                 {clientDetails?.clientName}
//                             </div>
//                             <div className={styles.mobGenWrapper}>
//                                 <div className={styles.mobile}>{clientDetails?.mobile}</div>
//                                 <div className={styles.gender}>{clientDetails?.gender}</div>
//                             </div>
//                         </div>
//                         <div className={styles.mhRight}>
//                             <div className={styles.eachNavOption}
//                                 onClick={() => setIsExtending(true)}
//                             >
//                                 <div className={styles.enoIcon}>
//                                     <TbRecharging size={22} />
//                                 </div>
//                                 <div className={styles.enoTxt}>
//                                     Renew
//                                 </div>
//                             </div>
//                             <div className={styles.eachNavOption}>
//                                 <div className={styles.enoIcon}>
//                                     <FiSettings size={22} />
//                                 </div>
//                                 <div className={styles.enoTxt}>
//                                     Setting
//                                 </div>
//                             </div>
//                             <div className={styles.eachNavOption}>
//                                 <div className={styles.enoIcon}>
//                                     <MdMoreHoriz size={22} />
//                                 </div>
//                                 <div className={styles.enoTxt}>
//                                     More
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className={styles.lowerWrapper}>
//                     <div className={styles.centerPage}>

//                         <div className={styles.mainBody}>
//                             {isLoading === true ?
//                                 <div className={styles.cardStrip}>
//                                     <div className={styles.cardStripLeft}>
//                                         <div className={styles.csUpper}>
//                                             <ShimmerThumbnail height={13} rounded width={100} className={styles.csUpperLoader} />
//                                         </div>
//                                         <div className={styles.csValue}>
//                                             <ShimmerThumbnail height={22} rounded width={140} className={styles.csUpperLoader} />
//                                         </div>
//                                         <div className={styles.csLower}>
//                                             <ShimmerThumbnail height={11} rounded width={70} className={styles.csUpperLoader} />
//                                         </div>
//                                     </div>
//                                     <div className={styles.cardStripRight}>
//                                         <div className={styles.viewDetailsBtn}>
//                                             Renew Card <MdArrowRight />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 :
//                                 <div className={styles.cardStrip}>
//                                     <div className={styles.cardStripLeft}>
//                                         <div className={styles.csUpper}>
//                                             Available Balance
//                                         </div>
//                                         <div className={styles.csValue}>
//                                             &#8377;{dcb?.currentBalance}/-
//                                         </div>
//                                         <div className={styles.csLower}>
//                                             1 Card
//                                         </div>
//                                     </div>
//                                     <div className={styles.cardStripRight}>
//                                         <div className={styles.viewDetailsBtn}
//                                             onClick={() => setIsExtending(true)}
//                                         >
//                                             Renew Card <MdArrowRight />
//                                         </div>
//                                     </div>
//                                 </div>
//                             }
//                             <div className={styles.cardDetailsSummaryWrapper}>
//                                 <div>
//                                     <div className={styles.cdsTitle}>
//                                         <div className={styles.cdsTitleCaption}>
//                                             Card Details
//                                         </div>
//                                         <div>
//                                             <MdCalendarToday />
//                                         </div>
//                                     </div>

//                                 </div>





//                                 <div className={styles.balanceSummaryWrapper}>
//                                     <div className={styles.eachBs}>
//                                         <div>

//                                         </div>
//                                         <div>
//                                             <div className={styles.bsCaption}>
//                                                 Total Earned
//                                             </div>
//                                             <div className={styles.bsValue}>
//                                                 <FaRupeeSign />{dcb?.allCredits}/-
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className={styles.eachBs}>
//                                         <div>

//                                         </div>
//                                         <div>
//                                             <div className={styles.bsCaption}>
//                                                 Total Added
//                                             </div>
//                                             <div className={styles.bsValue}>
//                                                 <FaRupeeSign />{dcb?.totalPaidAmount}/-
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className={styles.eachBs}>
//                                         <div>

//                                         </div>
//                                         <div>
//                                             <div className={styles.bsCaption}>
//                                                 Total Savings
//                                             </div>
//                                             <div className={styles.bsValue}>
//                                                 <FaRupeeSign />{parseFloat(dcb?.allCredits ?? 0) - parseFloat(dcb?.totalPaidAmount ?? 0)}/-
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className={styles.eachBs}>
//                                         <div>

//                                         </div>
//                                         <div>
//                                             <div className={styles.bsCaption}>
//                                                 Total Spend
//                                             </div>
//                                             <div className={styles.bsValue}>
//                                                 <FaRupeeSign />{dcb?.allDebits}/-
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div>
//                                     <div className={styles.cdsTitle}>
//                                         <div className={styles.cdsTitleCaption}>
//                                             Other Cards
//                                         </div>
//                                         <div>
//                                             {/* <MdCalendarToday /> */}
//                                         </div>
//                                     </div>
//                                     <div className={styles.boughtCardWrapper}>
//                                         {isLoading !== true ?
//                                             <div className={styles.boughtCardContainer}>
//                                                 {otherCards.map((item, index) => (
//                                                     <Link to={`/membership/` + item.issuedCardNumber} className={styles.eachCardWrapper}>
//                                                         <div className={styles.cardName}>
//                                                             GALLANT
//                                                         </div>
//                                                         <div>
//                                                             <div className={styles.cardNumber}>
//                                                                 <div>
//                                                                     {item.issuedCardNumber.substring(0, 4)}
//                                                                 </div>
//                                                                 <div>
//                                                                     {item.issuedCardNumber.substring(4, 8)}
//                                                                 </div>
//                                                                 <div>
//                                                                     {item.issuedCardNumber.substring(8, 12)}
//                                                                 </div>
//                                                                 <div>
//                                                                     {item.issuedCardNumber.substring(12, 16)}
//                                                                 </div>
//                                                             </div>
//                                                             <div className={styles.expiryDate}>
//                                                                 25-Jan-2028
//                                                             </div>
//                                                         </div>
//                                                     </Link>
//                                                 ))}

//                                                 <Link to="/memberships/add" className={styles.buyNewCardWrapper}>
//                                                     Buy New Card
//                                                 </Link>
//                                             </div>
//                                             :
//                                             <div className={styles.boughtCardContainer}>
//                                                 <ShimmerThumbnail height={139} width={282} className={styles.thumbnail} rounded />
//                                                 <ShimmerThumbnail height={139} width={282} className={styles.thumbnail} rounded />
//                                             </div>
//                                         }
//                                     </div>

//                                 </div>

//                             </div>



//                             {/* 
//                         <div className={styles.singleRow}>
//                             hey
//                         </div> */}

//                         </div>
//                     </div>
//                     <div className={styles.rightCol}>
//                         <TransactionsTable
//                             cardIdentifier={cardIdentifier}
//                         />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default CardDetails



import React, { useState, useEffect } from 'react';
import { CreditCard, TrendingUp, DollarSign, Calendar, Settings, MoreHorizontal, Zap, Eye, Plus, ArrowRight, Wallet, PiggyBank, ShoppingBag, Target, Award, Star, Activity, RefreshCw, Bell, Filter, Download, Search, Users, BarChart3, LineChart, Sparkles } from 'lucide-react';
import styles from './CardDetails.module.css';

const CardDetails = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [selectedTimeframe, setSelectedTimeframe] = useState('month');
    const [activeTab, setActiveTab] = useState('overview');

    // Simulated data
    const memberData = {
        clientName: "Alexandra Thompson",
        mobile: "+91 98765 43210",
        gender: "Female",
        memberSince: "Jan 2022",
        currentBalance: 12847.50,
        totalEarned: 45620.00,
        totalAdded: 32500.00,
        totalSpend: 32772.50,
        membershipLevel: "Platinum Elite",
        pointsBalance: 2450,
        nextTierPoints: 550
    };

    const otherCards = [
        { id: "5124567812345678", type: "Primary", balance: 12847.50, status: "Active" },
        { id: "5124567812345679", type: "Secondary", balance: 5420.00, status: "Active" },
        { id: "5124567812345680", type: "Corporate", balance: 8930.00, status: "Active" }
    ];

    const recentTransactions = [
        { id: 1, type: "Purchase", amount: -450.00, merchant: "Gallant Spa Premium", date: "Today, 2:30 PM", category: "Wellness" },
        { id: 2, type: "Reward", amount: +120.00, merchant: "Loyalty Bonus", date: "Today, 11:15 AM", category: "Rewards" },
        { id: 3, type: "Purchase", amount: -1200.00, merchant: "Gallant Fitness Elite", date: "Yesterday, 6:45 PM", category: "Fitness" },
        { id: 4, type: "Cashback", amount: +89.50, merchant: "Weekend Bonus", date: "Yesterday, 3:20 PM", category: "Cashback" },
        { id: 5, type: "Purchase", amount: -680.00, merchant: "Gallant Dining", date: "2 days ago", category: "Dining" }
    ];

    const analyticsData = [
        { month: 'Jan', spent: 2400, earned: 800 },
        { month: 'Feb', spent: 1398, earned: 600 },
        { month: 'Mar', spent: 9800, earned: 1200 },
        { month: 'Apr', spent: 3908, earned: 900 },
        { month: 'May', spent: 4800, earned: 1100 },
        { month: 'Jun', spent: 3800, earned: 950 }
    ];

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, []);

    if (isLoading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loader}>
                    <div className={styles.spinnerRing}></div>
                    <Sparkles className={styles.spinnerIcon} size={20} />
                </div>
            </div>
        );
    }

    return (
        <div className={styles.mainWrapper}>
            {/* Header */}
            <div className={styles.header}>
                <div className={styles.headerContent}>
                    <div className={styles.userInfo}>
                        <div className={styles.avatar}>
                            <span>AT</span>
                            <div className={styles.statusDot}></div>
                        </div>
                        <div className={styles.userDetails}>
                            <h1 className={styles.userName}>{memberData.clientName}</h1>
                            <div className={styles.userMeta}>
                                <span>{memberData.mobile}</span>
                                <span className={styles.separator}>•</span>
                                <span>{memberData.membershipLevel}</span>
                                <span className={styles.separator}>•</span>
                                <span>Member since {memberData.memberSince}</span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.headerActions}>
                        <button className={styles.actionBtn}>
                            <RefreshCw size={16} />
                            <span>Renew</span>
                        </button>
                        <button className={styles.iconBtn}>
                            <Bell size={16} />
                        </button>
                        <button className={styles.iconBtn}>
                            <Settings size={16} />
                        </button>
                        <button className={styles.iconBtn}>
                            <MoreHorizontal size={16} />
                        </button>
                    </div>
                </div>
            </div>

            <div className={styles.container}>
                {/* Stats Overview */}
                <div className={styles.statsGrid}>
                    <div className={`${styles.statCard} ${styles.balanceCard}`}>
                        <div className={styles.statHeader}>
                            <div className={styles.statIcon}>
                                <Wallet size={18} />
                            </div>
                            <div className={styles.statChange}>+12.5%</div>
                        </div>
                        <div className={styles.statContent}>
                            <div className={styles.statValue}>₹{memberData.currentBalance.toLocaleString()}</div>
                            <div className={styles.statLabel}>Available Balance</div>
                        </div>
                    </div>

                    <div className={`${styles.statCard} ${styles.earnedCard}`}>
                        <div className={styles.statHeader}>
                            <div className={styles.statIcon}>
                                <TrendingUp size={18} />
                            </div>
                            <div className={styles.statChange}>+8.2%</div>
                        </div>
                        <div className={styles.statContent}>
                            <div className={styles.statValue}>₹{memberData.totalEarned.toLocaleString()}</div>
                            <div className={styles.statLabel}>Total Earned</div>
                        </div>
                    </div>

                    <div className={`${styles.statCard} ${styles.savingsCard}`}>
                        <div className={styles.statHeader}>
                            <div className={styles.statIcon}>
                                <PiggyBank size={18} />
                            </div>
                            <div className={styles.statChange}>+15.3%</div>
                        </div>
                        <div className={styles.statContent}>
                            <div className={styles.statValue}>₹{(memberData.totalEarned - memberData.totalAdded).toLocaleString()}</div>
                            <div className={styles.statLabel}>Total Savings</div>
                        </div>
                    </div>

                    <div className={`${styles.statCard} ${styles.pointsCard}`}>
                        <div className={styles.statHeader}>
                            <div className={styles.statIcon}>
                                <Star size={18} />
                            </div>
                            <div className={styles.statChange}>+5.7%</div>
                        </div>
                        <div className={styles.statContent}>
                            <div className={styles.statValue}>{memberData.pointsBalance.toLocaleString()}</div>
                            <div className={styles.statLabel}>Loyalty Points</div>
                        </div>
                    </div>
                </div>

                {/* Main Content Grid */}
                <div className={styles.contentGrid}>
                    {/* Left Column */}
                    <div className={styles.leftColumn}>
                        {/* Primary Card */}
                        <div className={styles.card}>
                            <div className={styles.cardHeader}>
                                <h2 className={styles.cardTitle}>Primary Membership Card</h2>
                                <button className={styles.primaryBtn}>
                                    <Eye size={14} />
                                    <span>View Details</span>
                                </button>
                            </div>
                            <div className={styles.membershipCard}>
                                <div className={styles.cardTop}>
                                    <div className={styles.cardType}>GALLANT PRIMARY</div>
                                    <div className={styles.cardStatus}>Active</div>
                                </div>
                                <div className={styles.cardNumber}>5124 5678 1234 5678</div>
                                <div className={styles.cardBottom}>
                                    <div className={styles.cardBalance}>
                                        <div className={styles.balanceLabel}>Balance</div>
                                        <div className={styles.balanceAmount}>₹{memberData.currentBalance.toLocaleString()}</div>
                                    </div>
                                    <div className={styles.cardExpiry}>
                                        <div className={styles.expiryLabel}>Valid Thru</div>
                                        <div className={styles.expiryDate}>12/28</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Analytics */}
                        <div className={styles.card}>
                            <div className={styles.cardHeader}>
                                <h2 className={styles.cardTitle}>Spending Analytics</h2>
                                <div className={styles.timeframeSelector}>
                                    <button
                                        className={selectedTimeframe === 'week' ? styles.timeframeActive : styles.timeframeBtn}
                                        onClick={() => setSelectedTimeframe('week')}
                                    >
                                        Week
                                    </button>
                                    <button
                                        className={selectedTimeframe === 'month' ? styles.timeframeActive : styles.timeframeBtn}
                                        onClick={() => setSelectedTimeframe('month')}
                                    >
                                        Month
                                    </button>
                                    <button
                                        className={selectedTimeframe === 'year' ? styles.timeframeActive : styles.timeframeBtn}
                                        onClick={() => setSelectedTimeframe('year')}
                                    >
                                        Year
                                    </button>
                                </div>
                            </div>

                            <div className={styles.chartContainer}>
                                <div className={styles.chart}>
                                    {analyticsData.map((item, index) => (
                                        <div key={index} className={styles.chartBar}>
                                            <div className={styles.barGroup}>
                                                <div
                                                    className={styles.spentBar}
                                                    style={{ height: `${(item.spent / 100)}px` }}
                                                ></div>
                                                <div
                                                    className={styles.earnedBar}
                                                    style={{ height: `${(item.earned / 50)}px` }}
                                                ></div>
                                            </div>
                                            <div className={styles.barLabel}>{item.month}</div>
                                        </div>
                                    ))}
                                </div>

                                <div className={styles.chartLegend}>
                                    <div className={styles.legendItem}>
                                        <div className={`${styles.legendDot} ${styles.spentDot}`}></div>
                                        <span>Spent</span>
                                    </div>
                                    <div className={styles.legendItem}>
                                        <div className={`${styles.legendDot} ${styles.earnedDot}`}></div>
                                        <span>Earned</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Other Cards */}
                        <div className={styles.card}>
                            <div className={styles.cardHeader}>
                                <h2 className={styles.cardTitle}>Other Cards</h2>
                                <button className={styles.secondaryBtn}>
                                    <Plus size={14} />
                                    <span>Add Card</span>
                                </button>
                            </div>
                            <div className={styles.otherCardsGrid}>
                                {otherCards.slice(1).map((card, index) => (
                                    <div key={index} className={styles.miniCard}>
                                        <div className={styles.miniCardHeader}>
                                            <span className={styles.miniCardType}>GALLANT {card.type.toUpperCase()}</span>
                                            <span className={`${styles.miniCardStatus} ${card.status === 'Active' ? styles.statusActive : styles.statusInactive}`}>
                                                {card.status}
                                            </span>
                                        </div>
                                        <div className={styles.miniCardNumber}>{card.id.replace(/(.{4})/g, '$1 ').trim()}</div>
                                        <div className={styles.miniCardBalance}>₹{card.balance.toLocaleString()}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className={styles.rightColumn}>
                        {/* Recent Transactions */}
                        <div className={styles.card}>
                            <div className={styles.cardHeader}>
                                <h2 className={styles.cardTitle}>Recent Activity</h2>
                                <button className={styles.linkBtn}>
                                    <ArrowRight size={14} />
                                </button>
                            </div>
                            <div className={styles.transactionsList}>
                                {recentTransactions.slice(0, 6).map((transaction) => (
                                    <div key={transaction.id} className={styles.transactionItem}>
                                        <div className={styles.transactionLeft}>
                                            <div className={`${styles.transactionIcon} ${transaction.amount > 0 ? styles.positive : styles.negative}`}>
                                                {transaction.amount > 0 ? <TrendingUp size={12} /> : <ShoppingBag size={12} />}
                                            </div>
                                            <div className={styles.transactionDetails}>
                                                <div className={styles.transactionMerchant}>{transaction.merchant}</div>
                                                <div className={styles.transactionDate}>{transaction.date}</div>
                                            </div>
                                        </div>
                                        <div className={styles.transactionRight}>
                                            <div className={`${styles.transactionAmount} ${transaction.amount > 0 ? styles.positive : ''}`}>
                                                {transaction.amount > 0 ? '+' : ''}₹{Math.abs(transaction.amount).toLocaleString()}
                                            </div>
                                            <span className={styles.transactionCategory}>{transaction.category}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Progress Card */}
                        <div className={`${styles.card} ${styles.progressCard}`}>
                            <div className={styles.progressHeader}>
                                <Award size={20} />
                                <span className={styles.nextTierBadge}>Next Tier</span>
                            </div>
                            <h3 className={styles.progressTitle}>Diamond Elite</h3>
                            <p className={styles.progressSubtitle}>{memberData.nextTierPoints} points to go</p>
                            <div className={styles.progressBar}>
                                <div className={styles.progressFill} style={{ width: '78%' }}></div>
                            </div>
                            <p className={styles.progressPercent}>78% complete</p>
                        </div>

                        {/* Quick Actions */}
                        <div className={styles.card}>
                            <h2 className={styles.cardTitle}>Quick Actions</h2>
                            <div className={styles.actionsGrid}>
                                <button className={styles.actionItem}>
                                    <RefreshCw size={16} />
                                    <span>Recharge</span>
                                </button>
                                <button className={styles.actionItem}>
                                    <Download size={16} />
                                    <span>Statement</span>
                                </button>
                                <button className={styles.actionItem}>
                                    <Settings size={16} />
                                    <span>Settings</span>
                                </button>
                                <button className={styles.actionItem}>
                                    <Users size={16} />
                                    <span>Support</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardDetails;